import { all, select, put } from "redux-saga/effects";
import i18n from "i18next";
import {
  concurrentHandler,
  bufferedHandler,
  callback,
  evaluate,
} from "../../tools/effects";
import {
  generateLayer,
  createThumbnail,
  createThumbnailCSqueeze,
} from "../../../algorithms/imagery";
import { generateVisualizationParams } from "../../../algorithms/utils";
import { aggregateMissionsDates } from "../../../common/algorithms";
import { Types, Actions } from "./header";
import { Actions as Imagery } from "../imagery";
import { Actions as Map } from "../map";
import {
  getAcquisitionParameters,
  getImageryIdentifiers,
} from "../../../selectors";
import { ee } from "../../../services/earth-engine";
import { BathymetryResults } from "../../../app/pages/ProcessingBathymetryPage";
import { acquireFromDate } from "../../../algorithms/satellite/sentinel";

import { ConcreteLayer } from "../../../common/classes";

const handleLoadAvailableImages = function* () {
  const { satellite, geometry } = yield select(getAcquisitionParameters);

  const missions = satellite.missions;
  let availableByMission = [];

  for (let mission of missions) {
    try {
      let regionData = {
        name: mission.name,
        shortname: mission.shortname,
        dates: yield evaluate(mission.algorithms.queryAvailable(geometry)),
      };
      if (regionData.dates === null) {
        console.log("regionData.dates is null");
        continue;
      }
      if (
        Object.keys(regionData.dates).length === 0 &&
        mission.fallbackMission
      ) {
        yield put(Actions.setMissionFallback(mission));

        const fallback = mission.fallbackMission;

        regionData = {
          name: fallback.name,
          shortname: fallback.shortname,
          dates: yield evaluate(fallback.algorithms.queryAvailable(geometry)),
        };
      }
      availableByMission.push(regionData);
    } catch (e) {
      console.log("Error", mission, e);
    }
  }

  const availableDates = aggregateMissionsDates(availableByMission);

  if (availableDates !== undefined) {
    yield put(Actions.setAvailableDates(availableDates, availableByMission));
  }
};

const handleAcquireImage = function* ({ payload: { missionName, date } }) {
  const { geometry, satellite } = yield select(getAcquisitionParameters);
  const { imageId } = yield select(getImageryIdentifiers);

  const mission = satellite.get(missionName);
  //let image = mission.algorithms.acquire(date, geometry);

  let dtEnd = new Date().toISOString();
  console.log(
    "ImageId",
    imageId,
    "Mission name",
    "date",
    date,
    "dateend:",
    dtEnd,
    missionName,
    "satellite",
    mission
  );

  let image = null;
  if (BathymetryResults.isBathymetry()) {
    console.log("aquiring from date...");
    image = acquireFromDate(BathymetryResults.baseImageDate, mission, geometry);
    console.log("Image from date acquired", image);
  } else {
    image = ee
      .ImageCollection(missionName)
      .filterBounds(geometry)
      .filter(ee.Filter.date(date, dtEnd))
      .first();
    let missionInfo = missionName.split("/");

    if (missionInfo[0] === "LANDSAT") {
      function applyScaleFactors(img) {
        var opticalBands = img.select("SR_B.").multiply(0.0000275).add(-0.2);
        var thermalBands = img.select("ST_B.*").multiply(0.00341802).add(149.0);
        return img
          .addBands(opticalBands, null, true)
          .addBands(thermalBands, null, true);
      }
      //image = applyScaleFactors(image);
      let bands = [mission.bands.red, mission.bands.green, mission.bands.blue];
      let visualization = {
        bands: bands,
        min: 0.0,
        max: 0.4,
      };
      image = image.visualize(visualization);
      image = image.rename(bands).clip(geometry);
    }
  }

  const layer = generateLayer(
    image,
    mission,
    i18n.t("forms.imageryOverlay.base")
  );
  console.log("push Image", date);
  yield put(
    Imagery.pushImage(mission.shortname + "/" + date, date, mission.name)
  );

  yield put(Imagery.loadLayer(layer, imageId));
};

const handleLoadThumbnails = function* () {
  let { geometry, satellite, availableDates } = yield select(
    getAcquisitionParameters
  );
  console.log(
    "availableDates(handleLoadThumbnails) original (19.03)",
    availableDates
  );
  let id = 0;
  for (const entry of availableDates) {
    const mission = satellite.get(entry.name);
    console.log("MISSION", mission);
    console.log("Thumbnail img for", entry.id);

    let url = null;
    let clouds = null;
    // let imgCache = window.sessionStorage.getItem(entry.id+"_thumbnail");
    //if(imgCache === null){
    const image = mission.algorithms.acquire(entry.date, geometry);
    const visParam = generateVisualizationParams(mission);
    url = yield callback(
      window.location.href.indexOf("csqueeze") === -1
        ? createThumbnail
        : createThumbnailCSqueeze,
      image,
      geometry,
      visParam
    );
    //console.log("url", url,"visParam", visParam);
    clouds = yield evaluate(image.get("CLOUDS"));
    window.sessionStorage.setItem(
      entry.id + "_thumbnail",
      JSON.stringify({ url, clouds })
    );
    //}else{
    // imgCache = JSON.parse(imgCache);
    // url = imgCache.url;
    // clouds = imgCache.clouds;
    // }
    yield put(
      Actions.insertMetadata(entry.name, entry.date, {
        id: id++,
        thumbnail: url,
        clouds: clouds,
      })
    );
    console.log("entry after load thumbnail", entry);
  }
};

export class RawMapHelper {
  static lastRowMapId = null;
}

const handleFloodAnalysis = function* () {
  try {
    // 1. Initialize image and params
    const image = ee.ImageCollection("ESA/WorldCover/v200").first();
    const layer = {
      id: "mangrove_analysis",
      name: "Mangrove Analysis",
      params: {
        min: 95,
        max: 95,
        palette: ["000000", "red"],
      },
    };

    // 2. Get map ID
    yield put({ type: "EVALUATE" });
    const rawMapId = yield callback([image, image.getMap], layer.params);
    RawMapHelper.lastRowMapId = rawMapId;
    yield put({ type: "DONE" });

    // 3. Create source and overlay
    const source = new ee.layers.EarthEngineTileSource(rawMapId);
    const overlay = new ee.layers.ImageOverlay(source);

    // 4. Create concrete layer with proper structure
    const concrete = new ConcreteLayer(
      {
        image,
        params: layer.params,
        name: layer.name,
        id: layer.id,
      },
      overlay
    );

    // 5. Initialize custom layers if needed
    if (!Map.customLayers) {
      Map.customLayers = [];
    }

    // 6. Add to map with proper layer management
    yield put(Imagery.pushLayer(concrete));
    yield put(Map.addEELayer(overlay, layer.id, 0));
  } catch (error) {
    console.error("Mangrove analysis failed:", error);
    yield put({ type: "MANGROVE_ANALYSIS_FAILED", error: error.message });
  }

  // try {
  //   // const { coordinates, startDate, endDate } = payload;

  //   const coordinates = [-58.024429, 6.729363, -57.935249, 6.763412];

  //   const startDate = "2000-01-01";
  //   const endDate = "2020-01-01";

  //   // Create ROI from coordinates
  //   const roi = ee.Geometry.Polygon([coordinates]);

  //   // Get JRC water data
  //   const jrc = ee
  //     .ImageCollection("JRC/GSW1_4/MonthlyHistory")
  //     .filterBounds(roi)
  //     .filterDate(ee.Date(startDate), ee.Date(endDate));

  //   // Calculate flood frequency
  //   const calculateFloodFrequency = (collection) => {
  //     const addBands = (img) => {
  //       const obs = img.gt(0).rename("obs");
  //       const water = img.select("water").eq(2).rename("water");
  //       return img.addBands([obs, water]);
  //     };

  //     const withBands = collection.map(addBands);
  //     const totalObs = withBands.select("obs").sum();
  //     const totalWater = withBands.select("water").sum();
  //     return totalWater
  //       .divide(totalObs)
  //       .multiply(100)
  //       .rename("flood_frequency");
  //   };

  //   const floodFrequency = calculateFloodFrequency(jrc);

  //   // Add flood frequency layer to map
  //   yield put(
  //     Map.addEELayer(
  //       floodFrequency,
  //       {
  //         min: 0,
  //         max: 100,
  //         palette: ["white", "blue"],
  //       },
  //       "Flood Frequency",
  //       true
  //     )
  //   );
  // } catch (error) {
  //   console.error("Flood analysis failed:", error);
  // }

  // var dataset = ee.ImageCollection("ESA/WorldCover/v200").first();

  // // Cria uma máscara para manter apenas o mangue (valor 95 - mangue)
  // var mangroveMask = dataset.select("Map").eq(95);

  // // Aplica a máscara à imagem original
  // var mangroves = dataset.updateMask(mangroveMask);

  // var visualization = {
  //   min: 95,
  //   max: 95,
  //   palette: ["000000", "red"],
  // };

  // var slope = ee.Terrain.slope(mangroves);
  // var mapId = slope.getMap(visualization);
  // var tileSource = new ee.layers.EarthEngineTileSource(mapId);
  // var overlay = new ee.layers.ImageOverlay(tileSource);

  // return overlay;

  // try {
  //   const { coordinates, startDate, endDate, threshold } = payload;
  //   // const { coordinates, startDate, endDate, threshold } = payload;

  //   // Convert coordinates to EE geometry
  //   const roi = ee.Geometry.Polygon([coordinates]);

  //   // Load datasets
  //   const jrc = ee.ImageCollection("JRC/GSW1_4/MonthlyHistory")
  //     .filterBounds(roi)
  //     .filterDate(ee.Date(startDate), ee.Date(endDate));

  //   const srtm = ee.Image("USGS/SRTMGL1_003");
  //   const worldcover = ee.ImageCollection("ESA/WorldCover/v200").first().select("Map");
  //   const buildings = ee.FeatureCollection("GOOGLE/Research/open-buildings/v3/polygons");

  //   // Calculate flood frequency
  //   const calculateFloodFrequency = function(collection) {
  //     const addBands = function(img) {
  //       const obs = img.gt(0).rename("obs");
  //       const water = img.select("water").eq(2).rename("water");
  //       return img.addBands([obs, water]);
  //     };

  //     collection = collection.map(addBands);
  //     const total_obs = collection.select("obs").sum().rename("total_obs");
  //     const total_water = collection.select("water").sum().rename("total_water");
  //     const flood_frequency = total_water.divide(total_obs).multiply(100).rename("flood_frequency");
  //     return flood_frequency.updateMask(flood_frequency.neq(0));
  //   };

  //   const flood_frequency = calculateFloodFrequency(jrc);

  //   // Identify flood-prone areas
  //   const slope = ee.Terrain.slope(srtm).rename("slope");
  //   const flat_area = slope.lt(5).rename("flat_area");
  //   const low_lying = srtm.lt(threshold).rename("low_lying");
  //   const flood_prone_area = flood_frequency.updateMask(low_lying.And(flat_area));

  //   // Export results
  //   const exportParams = {
  //     collection: flood_prone_area,
  //     description: 'flood_prone_areas',
  //     folder: 'FloodAnalysis',
  //     fileFormat: 'GeoJSON'
  //   };

  //   ee.batch.Export.table.toDrive(exportParams);

  //   yield put(Actions.setFloodResults({
  //     floodProneArea: flood_prone_area,
  //     // Add other results as needed
  //   }));

  // } catch (error) {
  //   console.error('Flood analysis failed:', error);
  // }
};

const root = function* () {
  yield all([
    concurrentHandler(Types.LOAD_AVAILABLE_IMAGES, handleLoadAvailableImages),
    bufferedHandler(Types.ACQUIRE_IMAGE, handleAcquireImage),
    concurrentHandler(Types.LOAD_THUMBNAILS, handleLoadThumbnails),
    concurrentHandler(Types.START_FLOOD_ANALYSIS, handleFloodAnalysis),
  ]);
};

export default root;
